import { Typography, Tabs, Col, Row } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import { mqtt } from "aws-iot-device-sdk-v2";
import { v4 as uuid } from 'uuid';
import { LISTENERS } from '../common/Constants';
import JobDocumentViewer from './TestClient/JobDocumentViewer';
import OnGoingDeployments from './TestClient/OnGoingDeployments';
import IncomingDeployments from './TestClient/IncomingDeployments';
import VehicleDetails from './TestClient/VehicleDetails';
import { SimulatorContext } from 'store/context';
import { connect_websocket } from 'mqtt/aws';

const { Title } = Typography;

const AndroidTestClient = () => {

  const {
    stsToken: credentials,
    vehicleSimulatorSettings: { serialNo },
  } = useContext(SimulatorContext);

  const [pendingJobs, setPendingJobs] = useState({
    inProgressJobs: [],
    queuedJobs: []
  });
  const [isPendingJobLoading, setPendingJobLoading] = useState(false);
  const [lookDep, setLookDep] = useState(false);
  const [onGoingExecution, setOnGoingExecution] = useState({});
  const [fetchJobDetails, setFetchJobDetails] = useState('');
  const [fetchJobDocument, setFetchJobDocument] = useState(false);
  const [selectedExecutionStatus, setSelectedExecutionStatus] = useState(null);
  const [selectedSignal, setSelectedsignal] = useState('');
  const [jobDocument, setJobDocument] = useState({});
  const [api, setApi] = useState([]);

  const {
    inProgressJobs = [],
    queuedJobs = []
  } = pendingJobs || {};

  function updateApi(endpoint, title) {
    setApi([{
      endpoint,
      type: 'info',
      title
    },
    ...api
    ]);
    console.log(api)
  }

  const updateExecutionSignal = () => {
    const data = {
      id: uuid(),
      schemaVersion: 'v1',
      type: 'OTA_UPDATE',
      client: localStorage.getItem("simulatorCustomer") || 'visteon',
      data: {
        serialNo,
        jobId: fetchJobDetails,
        signal: selectedSignal,
        eventTime: new Date(Date.now()).toISOString(),
        client_token: uuid()
      }
    }
    updateSignalJobMQTTProcess(data);
  }

  const pendingJobMQTTProcess = () => {
    setPendingJobLoading(true);
    connect_websocket(credentials, LISTENERS.PENDING_JOBS)
      .then((connection) => {
        connection
          .subscribe(
            `kyoto/things/${serialNo}/jobs/get/accepted`,
            mqtt.QoS.AtLeastOnce,
            (topic, payload) => {
              console.log(`message received in ${topic}`);
              const decoder = new TextDecoder("utf8");
              let message = decoder.decode(new Uint8Array(payload));
              const data = JSON.parse(message);
              console.log(data)
              setPendingJobs(data);
              connection.disconnect();
              setPendingJobLoading(false);
            }
          )
          .then(() => {
            updateApi(`kyoto/things/${serialNo}/jobs/get/accepted`, 'PendingJobsAccepted - Connected')
            connection.subscribe(
              `kyoto/things/${serialNo}/jobs/get/rejected`,
              mqtt.QoS.AtLeastOnce,
              (topic, payload) => {
                console.log(`message received in ${topic}`);
                const decoder = new TextDecoder("utf8");
                let message = decoder.decode(new Uint8Array(payload));
                const data = JSON.parse(message);
                console.log(data)
                connection.disconnect();
                setPendingJobLoading(false)
              }
            ).then((subscription) => {
              updateApi(`kyoto/things/${serialNo}/jobs/get/rejected`, 'PendingJobsRejected - Connected')
              connection.publish(`kyoto/things/${serialNo}/jobs/get`, "{}", subscription.qos).then(() => {
                console.log(`published to kyoto/things/${serialNo}/jobs/get`)
                updateApi(`kyoto/things/${serialNo}/jobs/get`, 'PendingJobs - Published')
              });
            });
          })
      })
      .catch((reason) => {
      })
      .finally(() => {
      });
  };

  const describeJobMQTTProcess = () => {
    connect_websocket(credentials, LISTENERS.JOB_DETAILS)
      .then((connection) => {
        connection
          .subscribe(
            `kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/accepted`,
            mqtt.QoS.AtLeastOnce,
            (topic, payload) => {
              console.log(`message received in ${topic}`);
              const decoder = new TextDecoder("utf8");
              let message = decoder.decode(new Uint8Array(payload));
              const data = JSON.parse(message);
              console.log(data)
              setOnGoingExecution(data?.execution)
              console.log(data?.execution?.document)
              setJobDocument(JSON.parse(data?.execution?.document?.document));
              connection.disconnect();
            }
          )
          .then(() => {
            updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/accepted`, 'DescribeJobsAccepted - Connected')
            connection.subscribe(
              `kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/rejected`,
              mqtt.QoS.AtLeastOnce,
              (topic, payload) => {
                console.log(`message received in ${topic}`);
                const decoder = new TextDecoder("utf8");
                let message = decoder.decode(new Uint8Array(payload));
                connection.disconnect();
                const data = JSON.parse(message);
                console.log(data)
                // setDesired(remoteFunctions);
                // setPendingJobLoading(false)
              }
            ).then((subscription) => {
              updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get/accepted`, 'DescribeJobsRejected - Connected')
              connection.publish(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get`, JSON.stringify({ includeJobDocument: true }), subscription.qos).then(() => {
                console.log(`published to kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get`)
                updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/get`, 'DescribeJobs - Published')
              });
            });
          })
      })
      .catch((reason) => {
      })
      .finally(() => {
      });
  };

  const updateJobMQTTProcess = (status) => {
    connect_websocket(credentials, LISTENERS.UPDATE_JOB)
      .then((connection) => {
        connection
          .subscribe(
            `kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/accepted`,
            mqtt.QoS.AtLeastOnce,
            (topic, payload) => {
              console.log(`message received in ${topic}`);
              const decoder = new TextDecoder("utf8");
              let message = decoder.decode(new Uint8Array(payload));
              const data = JSON.parse(message);
              console.log(data)
              pendingJobMQTTProcess();
              describeJobMQTTProcess();
              connection.disconnect();
            }
          )
          .then(() => {
            updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/accepted`, 'UpdateJobsAccepted - Connected')
            connection.subscribe(
              `kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/rejected`,
              mqtt.QoS.AtLeastOnce,
              (topic, payload) => {
                console.log(`message received in ${topic}`);
                const decoder = new TextDecoder("utf8");
                let message = decoder.decode(new Uint8Array(payload));
                connection.disconnect();
                const data = JSON.parse(message);
                console.log(data)
              }
            ).then((subscription) => {
              updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update/rejected`, 'UpdateJobsRejected - Connected')
              connection.publish(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update`, JSON.stringify({ status }), subscription.qos).then(() => {
                console.log(`published to kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update`)
                updateApi(`kyoto/things/${serialNo}/jobs/${fetchJobDetails}/update`, 'UpdateJobs - Published')
              });
            });
          })
      })
      .catch((reason) => {
      })
      .finally(() => {
      });
  };


  const updateSignalJobMQTTProcess = (data) => {
    connect_websocket(credentials, LISTENERS.UPDATE_SIGNAL)
      .then((connection) => {
        connection.publish(`visteon/nextdev/jobs/${fetchJobDetails}`, JSON.stringify(data), 0).then(() => {
          updateApi(`visteon/nextdev/jobs/${fetchJobDetails}`, 'UpdateSignal - Published')
        });
      })
      .catch((reason) => {
      })
      .finally(() => {
      });
  };

  useEffect(() => {
    if (lookDep) {
      pendingJobMQTTProcess();
    }
  }, [lookDep]);

  useEffect(() => {
    if (fetchJobDetails) {
      describeJobMQTTProcess();
    }
  }, [fetchJobDetails])

  const items = [
    {
      key: 'on_going',
      label: 'On Going Job Executions',
      children: <OnGoingDeployments
        onGoingExecution={onGoingExecution}
        jobDocument={jobDocument}
        selectedExecutionStatus={selectedExecutionStatus}
        setSelectedExecutionStatus={setSelectedExecutionStatus}
        setSelectedsignal={setSelectedsignal}
        setFetchJobDocument={setFetchJobDocument}
        updateJobMQTTProcess={updateJobMQTTProcess}
        updateExecutionSignal={updateExecutionSignal}
      />,
    },
    {
      key: 'job_document',
      label: 'Job Document',
      children: <JobDocumentViewer onGoingExecution={onGoingExecution} jobDocument={jobDocument} />,
    },
  ];


  return (
    <>
      <Typography>
        <Title level={3} style={{ margin: 0, marginBottom: '10px' }}>Android Test Client</Title>
      </Typography>
      <div style={{ margin: '3%' }}>
        <Row gutter={32}>
          <Col span={7}>
            <VehicleDetails
              fetchJobDetails={fetchJobDetails}
              api={api}
              setLookDep={setLookDep}
            />
          </Col>
          <Col span={7}>
            <IncomingDeployments
              inProgressJobs={inProgressJobs}
              queuedJobs={queuedJobs}
              setFetchJobDetails={setFetchJobDetails}
              isPendingJobLoading={isPendingJobLoading}
            />
          </Col>
          <Col span={10}>
            <Tabs defaultActiveKey="1" items={items} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AndroidTestClient;